import { render, staticRenderFns } from "./BacklinkButton.vue?vue&type=template&id=68a2421d&scoped=true&"
import script from "./BacklinkButton.vue?vue&type=script&lang=js&"
export * from "./BacklinkButton.vue?vue&type=script&lang=js&"
import style0 from "./BacklinkButton.vue?vue&type=style&index=0&id=68a2421d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a2421d",
  null
  
)

export default component.exports